import { AssetPipe } from '@libraries/asset/asset.pipe';
import { ButtonComponent } from '@shared/button/button.component';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NgClass, NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { HeaderTitleComponent } from '@shared/header-title/header-title.component';
import { BorderButtonComponent } from '@shared/border-button/border-button.component';
import { RouterLinkWithHref } from '@angular/router';
import { AppPath } from '@shared/routes/app-routing.const';
import { GridComponent } from '@shared/grid/grid.component';
import { AnchorLabelPipe } from '@libraries/anchor/anchor-label.pipe';

@Component({
    selector: 'jsdaddy-technologies',
    standalone: true,
    imports: [
        NgTemplateOutlet,
        RouterLinkWithHref,
        ButtonComponent,
        HeaderTitleComponent,
        AssetPipe,
        BorderButtonComponent,
        GridComponent,
        NgOptimizedImage,
        AnchorLabelPipe,
        NgClass,
    ],
    templateUrl: './technologies.component.html',
    styleUrl: './technologies.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TechnologiesComponent {
    public readonly contactUsPath = `/${AppPath.CONTACT_US}`;

    public readonly technologies = [
        'bun',
        'flutter',
        'angular',
        'react',
        'js-ts',
        'nodejs',
        'nestjs',
        'dart',
        '',
    ];
}
